import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import { PLACEHOLDER_MESSAGES } from '../../constants';
import TooltipField from 'scenes/ProjectMultiStepForm/components/TooltipField';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import trashIcon from "./img/trash-icon.svg";
import "./styles/CustomFileInput.scss";
import useMediaQuery from 'utils/hooks/useMediaQuery';
import closeIcon from "utils/components/MultiSelect/components/MultiSelectOption/img/close.png";
import { graphql } from 'react-apollo';
import { uploadImages } from '../../mutation';
import classNames from 'classnames';

const CustomFileInput = ({ uploadFile }) => {
  const intl = useIntl()
  const fileInputRef = useRef(null);
  const isMobile = useMediaQuery("(max-width: 992px)");
  const { 
    values: { authorizationProject, authorizationSupport }, setFieldValue 
  } = useFormikContext();
  
  const [errorMessage, setErrorMessage] = useState("");
  const [filename, setFilename] = useState(authorizationSupport || "");
  const [loading, setLoading] = useState(false);

  const handleFileChange = async () => {
    const file = fileInputRef.current.files[0];

    if (file) {
      setLoading(true);

      try {
        const { data } = await uploadFile({
          variables: {
            file,
          },
        });
        const { uploadPermissionFileProjects } = data;
        const { path } = uploadPermissionFileProjects;
        
        if (path) {
          setLoading(false);
          setFilename(file.name);
          setFieldValue("authorizationSupport", path);
          setErrorMessage("");
        }
      } catch (error) {
        const { graphQLErrors } = error;
        const errorMessage = graphQLErrors[0]?.message;
        
        setLoading(false);
        setFilename("");
        setErrorMessage("ProjectStepForm.step3.field.fileError");
  
        console.error("Error upload support image/pdf/docx:", errorMessage);
      }
    } else {
      setFilename("");
      setErrorMessage("ProjectStepForm.step3.field.fileError");
    }
  };
  
  const handleDeleteSelectedFile = () => {
    setFilename("");
    setFieldValue("authorizationSupport", null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  const triggerFileInput = () => {
    document.getElementById('authorizationSupport').click();
  };

  return (
    authorizationProject && (
      <div className="step-0-form__selects d-lg-flex">
        <div className="col-12 col-lg-12 px-0 mb-3 mb-lg-0">
          <label
            className="step-0-form__label p-0 m-0 mb-lg-1 font-weight-bold"
            htmlFor="authorizationSupport"
          >
            <FormattedMessage
              id="ProjectStepForm.step3.field.authorizationSupport"
              defaultMessage="Carta, imagen, contrato o soporte de autorización de uso"
            />
            {"*"}
          </label>
          <div className="form-control bg-transparent d-flex justify-content-between align-items-center">
            <span className="custom-file-input__file-name d-flex align-items-center">
              {filename ? (
                <span
                  className={classNames({
                    "file-name-text col-4 col-lg-10 d-inline-block": filename,
                    "text-black": filename
                  })}
                >
                  {filename}
                </span>
              ) : loading ? (
                <FormattedMessage
                  id="ProjectStepForm.step3.field.loadingFile"
                  defaultMessage="Cargando archivo..."
                />
              ) : (
                <FormattedMessage
                  id="ProjectStepForm.step3.field.authorizationSupport.placeholder"
                  defaultMessage="Comprobante de autorización de uso"
                />
              )}
              {filename && (
                <img
                  className="ml-2"
                  src={closeIcon}
                  alt="close-icon"
                  width={9}
                  height={9}
                  onClick={handleDeleteSelectedFile}
                />
              )}
            </span>
            <button
              className="custom-file-input__button-file border-0 px-3 rounded"
              type="button"
              onClick={triggerFileInput}
            >
              <img src={trashIcon} alt="trash-icon" width={18} height={18} />
              {!isMobile && (
                <p className="p-0 m-0 d-inline ml-2">
                  <FormattedMessage
                    id="ProjectStepForm.step3.field.selectFileBtn"
                    defaultMessage="Examinar..."
                  />
                </p>
              )}
            </button>
          </div>
          <div className="custom-file-input__info col-12 text-center">
            <FormattedMessage
              id="ProjectStepForm.step3.field.info"
              defaultMessage=" Sube tu comprobante de autorización en formato JPEG, DOCX o PDF (máx. 2 MB)"
            />
          </div>
          <input
            ref={fileInputRef}
            type="file"
            id="authorizationSupport"
            name="authorizationSupport"
            className="d-none"
            placeholder={intl.formatMessage(
              PLACEHOLDER_MESSAGES.authorizationSupport
            )}
            onChange={handleFileChange}
            accept=".jpeg, .docx, .pdf"
          />
          <ErrorMessage
            className="form-error-message"
            component="div"
            name="authorizationSupport"
          />
          {errorMessage && (
            <span className="form-error-message">
              <FormattedMessage id={errorMessage} />
            </span>
          )}
        </div>
      </div>
    )
  );
}

export default  graphql(uploadImages, { name: "uploadFile" }) (CustomFileInput);
